define('NVT.membershipdirectory.membershipdirectory.Model',
[
    'SCModel',
    'Utils'
],
function
(
    SCModelModule,
    Utils
) {
    'use strict';
 
    var SCModel = SCModelModule.SCModel;
 
    function MembershipDirectoryModel (model, options) {
        SCModel.call(this, model, options);
 
        this.urlRoot = function urlRoot () {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "Modules/membershipdirectory/SuiteScript2/membershipdirectory.Service.ss"
                ), true
            )
        }
    }
 
    MembershipDirectoryModel.prototype = Object.create(SCModel.prototype);
    MembershipDirectoryModel.prototype.constructor = MembershipDirectoryModel;
    
    return MembershipDirectoryModel
})
